// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { Holding } from '@daml.js/utility-registry-holding-v0/lib/Utility/Registry/Holding/V0/Holding';
import TemplateContract from './TemplateContract';

type Args = {
  owner: string;
  holdings: TemplateContract<Holding>[];
};
export const filterHoldingsByOwner = (arg: Args) => {
  const { owner, holdings } = arg;
  return holdings.filter((h) => h.payload.owner === owner);
};
